var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"bi bi-circle-fill mx-1",class:_vm.overdueColor,staticStyle:{"font-size":"10px"}})}
var staticRenderFns = []

export { render, staticRenderFns }